import { useQuery } from "@tanstack/react-query";
import { client } from "./api-client";

export const useLookupCitSites = (id) =>
  useQuery({
    queryFn: () =>
      client(`lookups/customer/cit/sites/${id}`, {
        data: { id },
      }),
    queryKey: ["locations", id],
    retry: false,
  });

export const useLookupCashCenters = () =>
  useQuery({
    queryFn: () => client(`lookups/cash/centers`),
    queryKey: ["CashCenters"],
    retry: false,
  });

export const useLookupATMList = (id) =>
  useQuery({
    queryFn: () => client(`lookups/customer/atm/sites/${id}`),
    queryKey: ["ATMList", id],
    retry: false,
  });

export const useLookupCurrency = () =>
  useQuery({
    queryFn: () => client(`lookups/currencies`),
    queryKey: ["currencies"],
    retry: false,
  });

export const useLookupCountries = () =>
  useQuery({
    queryFn: () => client(`lookups/countries`),
    queryKey: ["Countries"],
    retry: false,
  });

export const useLookupNationalities = () =>
  useQuery({
    queryFn: () => client(`lookups/nationalities`),
    queryKey: ["Nationalities"],
    retry: false,
  });

export const useLookupCDM = (id) =>
  useQuery({
    queryFn: () => client(`lookups/customer/cdm/sites/${id}`),
    queryKey: ["CDM", id],
    retry: false,
  });

export const useLookupMachineList = (id) =>
  useQuery({
    queryFn: () => client(`lookups/customer/machine/sites/${id}`),
    queryKey: ["machineList", id],
    retry: false,
  });

export const useLookupDesignations = () =>
  useQuery({
    queryFn: () => client(`lookups/designations`),
    queryKey: ["Customer Designations"],
    retry: false,
  });
export const useLookupRolesPermission = () =>
  useQuery({
    queryFn: () => client(`lookups/role/permissions`),
    queryKey: ["rolePermissions"],
    retry: false,
  });

export const useLookupResources = () =>
  useQuery({
    queryFn: () => client(`lookups/lynx/resources`),
    queryKey: ["lookupsResources"],
    retry: false,
  });
export const useLookupPermissions = () =>
  useQuery({
    queryFn: () => client(`lookups/lynx/permissions`),
    queryKey: ["lookupsPermissions"],
    retry: false,
  });

export const useLookupPendingReasons = (data) =>
  useQuery({
    queryFn: () => client(`lookups/pending/reasons/${data}`),
    queryKey: [`PendingReasons${data}`],
    retry: false,
  });

export const useLookupOffices = (data) =>
  useQuery({
    queryFn: () => client(`lookups/cash/center/offices/${data}`),
    queryKey: [`Offices${data}`],
    retry: false,
  });

export const useGetBagTypes = () =>
  useQuery({
    queryFn: () => client(`lookups/bag/types`),
    queryKey: [`BagTypes`],
  });

export const useAutocompleteAllLocations = (search) =>
  useQuery({
    queryKey: [`AllLocations`, search],
    queryFn: () =>
      client(`lookups/locations/autocomplete?searchString=${search}`),
    enabled: search.length >= 5,
  });

export const useLookupEmployees = () =>
  useQuery({
    queryFn: () => client(`lookups/employees`),
    queryKey: ["employeed"],
  });

export const useLookupServiceTypes = () =>
  useQuery({
    queryFn: () => client(`lookups/service/types`),
    queryKey: ["serviceTypes"],
  });
